export const breakpoints = {
    values: {
        xs: 0,
        sm: 1024,
        md: 1440,
        lg: 1920,
        xl: 2560
    }
};
//# sourceMappingURL=breakpoints.js.map